import { InsuranceCoverageStatusOverviewEmailEditForm } from "application/insurance-coverage-status-overview/forms";
import { BaseEditViewStore } from "core/stores";
import { applicationContext } from "core/utils";
import { action, observable, runInAction } from "mobx";
import { InsuranceCoverageStatusOverviewService } from "application/insurance-coverage-status-overview/services";
import { ModalParams } from "core/models";
import { FacilityOrderService } from "../../facility-order/services";
@applicationContext
class InsuranceCoverageStatusOverviewEmailEditViewStore extends BaseEditViewStore {
    @observable accessor body = null;
    @observable accessor isLoading = null;
    @observable accessor isNewFlow2 = true;
    @observable accessor isPickTicketCreated = false;
    @observable accessor fetchingData = false;
    @observable accessor isEmailSent = false;
    @observable accessor emailSentInfo = '';
    @observable accessor isManuallyLoading = null;
    @observable accessor isNiko = false;
    
    constructor(rootStore) {
        const insuranceCoverageStatusOverviewService = new InsuranceCoverageStatusOverviewService(rootStore.application.baasic.apiClient);
        const facilityOrderId = rootStore.routerStore.routerState.params.facilityOrderId;
        super(rootStore, {
            name: "insurance-coverage-status-email-edit",
            Form: InsuranceCoverageStatusOverviewEmailEditForm,
            actions: () => { },
            FormClass: InsuranceCoverageStatusOverviewEmailEditForm,
        });

        this.insuranceCoverageStatusOverviewService = insuranceCoverageStatusOverviewService;
        this.facilityOrderId = facilityOrderId;

        this.isNiko = rootStore.routerStore.routerState.queryParams.isNiko;
        this.isNiko = this.isNiko === 'true';

        this.getEmailPrefillData(facilityOrderId);
        this.loggedUserId = rootStore.userStore.applicationUser.id;

        this.sendManuallyConfirmationModal = new ModalParams({ onClose: null });
        this.sendManuallyConfirmationModal.onConfirm = async () => { await this.sendEmailManually(); this.sendManuallyConfirmationModal.close(); };
        this.sendManuallyConfirmationModal.onCancel = () => { this.sendManuallyConfirmationModal.close() };
    }

    @action.bound
    async getEmailPrefillData(facilityOrderId) {
        try {
            runInAction(() => {
                this.fetchingData = true;
            });
            const response = this.isNiko ?
            await this.insuranceCoverageStatusOverviewService.getNikoEmailPrefillData(facilityOrderId) :
            await this.insuranceCoverageStatusOverviewService.getEmailPrefillData(facilityOrderId);
            this.form.update(response.data);
            this.rootStore.titleStore.setTitle(response.data.facilityName ? `ICSO - ${response.data.facilityName}` : 'Insurance Coverage Status Overview');
            runInAction(() => {
                this.isNewFlow2 = response.data.isNewFlow2;
                this.body = response.data.body;
                this.isPickTicketCreated = response.data.pickTicketHeaderId !== null;
                this.fetchingData = false;
                this.isEmailSent = response.data.isICSOEmailSent;
            });
            if (this.isEmailSent) {
                await this.setEmailSentInfo();
            }
        }
        catch (err) {
            let errorMessage = typeof err.data === "object" ? err.data.errorMessage : err.data;
            this.rootStore.notificationStore.error(errorMessage ? errorMessage : "INSURANCE_COVERAGE_STATUS_OVERVIEW.ERROR_EMAIL_PREFILL");
            runInAction(() => {
                this.fetchingData = false;
            });
        }
    }
    @action.bound
    async download() {
        const { notificationStore } = this.rootStore;

        const resource = this.form.values();
        var fileName = resource.subject + '.msg';

        var xhr = new XMLHttpRequest();
        xhr.open('POST', `${this.insuranceCoverageStatusOverviewService.getDownloadUrl()}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl
            }&ttype=${this.rootStore.authStore.token.type}`, true);

        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.setRequestHeader('Asccept', '*/*');

        xhr.responseType = 'arraybuffer'; // this is required

        xhr.onload = function () {
            if (this.status == 200) {
                var blob = new Blob([this.response], { type: "application/octet-stream" });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                link.remove();
                // in case the Blob uses a lot of memory
                setTimeout(() => URL.revokeObjectURL(link.href), 7000);
            }
            else {
                notificationStore.error("Error occured while trying to download email.");
            }
        };

        // create a JSON object
        const json = {
            userId: this.loggedUserId,
            facilityOrderId: this.facilityOrderId,
            body: resource.body,
            cc: resource.cc,
            to: resource.to,
            includePickTicket: resource.includePickTicket,
            replyTo: resource.replyTo,
            subject: resource.subject
        }

        // send rquest with JSON payload
        xhr.send(JSON.stringify(json));
        if (!this.isEmailSent) this.rootStore.notificationStore.warning('If sending the email manually, please click on the “Sent Manually” button to confirm that you’ve done so.');
    }

    @action.bound
    async sendEmail() {
        try {
            this.isLoading = true;
            const resource = this.form.values();
            await this.insuranceCoverageStatusOverviewService.sendEmail({ ...resource, facilityOrderId: this.facilityOrderId });
            this.isLoading = false;
            this.isEmailSent = true;
            this.rootStore.notificationStore.success("Email successfully sent.");
        }
        catch (err) {
            this.isLoading = false;
            let errorMessage = typeof err.data === "object" ? err.data.errorMessage : err.data;
            this.rootStore.notificationStore.error(errorMessage ? errorMessage : "INSURANCE_COVERAGE_STATUS_OVERVIEW.ERROR_EMAIL_SEND");
        }
    }

    @action.bound
    opetSendEmailManuallyModal() {
        this.sendManuallyConfirmationModal.open({
            message: "Send email manually?"
        });
    }

    @action.bound
    async sendEmailManually() {
        this.isManuallyLoading = true;
        await this.insuranceCoverageStatusOverviewService.sendEmailManually({ facilityOrderId: this.facilityOrderId });
        this.isEmailSent = true;
        this.isManuallyLoading = false;
    }

    closePage() {
        window.close();
    }

    @action.bound
    async signalRAction(message) {
        if (message.table == "SE") {
            if (message.column == "EmailType") {
                if(message.text == "ICSO" && message.id == this.facilityOrderId)
                {
                    this.isEmailSent = true;
                    if (this.emailSentInfo == '') {
                        await this.setEmailSentInfo();
                    }
                }
            }
        }
    }

    @action.bound
    async setEmailSentInfo() {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        const sentEmailResponse = (await facilityOrderService.getSentEmailInfo(this.facilityOrderId, "ICSO")).data;

        if (sentEmailResponse) {
            const formattedDate = new Date(sentEmailResponse.eventDate).toLocaleString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            });

            this.emailSentInfo = `Sent by ${sentEmailResponse.name} on ${formattedDate}`;
        } else {
            this.emailSentInfo = '';
        }
    }
}

export default InsuranceCoverageStatusOverviewEmailEditViewStore;
